import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const selectFormsState = (state: RootState) => state.forms;
const selectFormBuilderState = createSelector(selectFormsState, (forms) => forms.formBuilder);

export const selectFields = createSelector(selectFormBuilderState, (fb) => fb.fields);

export const selectSelectedFieldId = createSelector(selectFormBuilderState, (fb) => fb.selectedFieldId);

export const selectIsDirty = createSelector(selectFormBuilderState, (fb) => fb.isDirty);

export const selectSelectedField = createSelector(
  selectFields,
  selectSelectedFieldId,
  (fields, selectedId) => fields.find((f) => f.id === selectedId) ?? null,
);
